module.exports = __webpack_public_path__ + "account_center_logo.3e0b025f.svg";